import React from 'react'
import { Alert } from 'antd'

import type { LntAlertProps } from './types'

export const LntAlert: React.FC<LntAlertProps> = props => {
  return <Alert { ...props } />
}
